import apiClient from "@/utils/apiClient";

export const invoiceService = {
  getAll: async (params = {}) => {
    const res = await apiClient.get("/invoices", { params });
    return res.data;
  },

  generate: async (bookingId, data) => {
    const res = await apiClient.post(`/invoices/generate/${bookingId}`, data);
    return res.data;
  },

  send: async (id, data) => {
    const res = await apiClient.post(`/invoices/${id}/send`, data);
    return res.data;
  },

  updateStatus: async (id, data) => {
    const res = await apiClient.put(`/invoices/${id}/status`, data);
    return res.data;
  },

  getStats: async (params = {}) => {
    const res = await apiClient.get("/accounting/stats", { params });
    return res.data;
  },

  download: async (id) => {
    const res = await apiClient.get(`/invoices/${id}/pdf`, {
      responseType: "blob",
    });
    return res.data;
  },
};
